
import React from 'react';
import { Briefcase } from 'lucide-react';
import { EXPERIENCE } from '../constants';

const Experience: React.FC<{ darkMode: boolean }> = ({ darkMode }) => {
  return (
    <div className="py-10">
      <div className="flex items-center gap-3 mb-12">
        <Briefcase className="text-blue-600" />
        <h3 className="text-3xl font-bold">Experience</h3>
      </div>

      <div className="relative border-l-2 border-slate-200 dark:border-slate-800 ml-4 space-y-12">
        {EXPERIENCE.map((exp, idx) => (
          <div key={idx} className="relative pl-10">
          <div className={`absolute -left-[11px] top-0 w-5 h-5 bg-blue-600 rounded-full border-4 transition-colors duration-300 ${darkMode ? 'border-slate-950' : 'border-white'}`}></div>
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-2">
              <div>
                <h4 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-slate-900'}`}>{exp.role}</h4>
                <div className={`${darkMode ? 'text-blue-600 font-semibold' : 'text-slate-700 font-medium'}`}>{exp.company}</div>
              </div>
              <div className={`bg-slate-100 ${darkMode ? 'dark:bg-slate-800' : ''} text-slate-600 ${darkMode ? 'dark:text-slate-400' : ''} px-4 py-1 rounded-full text-sm font-medium h-fit`}>
                {exp.period}
              </div>
            </div>
            <ul className="space-y-3 text-slate-600 dark:text-slate-400 list-disc list-inside">
              {exp.description.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;
